module.exports = __webpack_public_path__ + "static/media/panel_JVEquity.feb34eee.jpg";